import React from 'react'

import { Icon, InlineButton } from '../../../index'
import { useVisibility } from '../../../../utils'
import { useTranslation } from '../../../../utils/providers'

import SortFlyout from './SortFlyout'

function SortButton(props) {
  const { t } = useTranslation()
  const { isVisible, show, hide } = useVisibility()

  const label = t('SORT_HEADING')

  return (
    <>
      <InlineButton
        title={label}
        aria-label={label}
        aria-expanded={isVisible}
        aria-controls="product-list-sort-form"
        onClick={show}
        className="d-flex px-3 py-1"
      >
        <Icon symbol="cf-sort" />
      </InlineButton>
      <SortFlyout hide={hide} isVisible={isVisible} {...props} />
    </>
  )
}

export default SortButton
